import React from 'react';
import { Box, Grid, Paper } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import { DateFromTo } from '../../../../generated/graphql';
import { getUrlParams, setUrlParams } from '../../../../utils/helpers/urlParams';
import { FromToContextProvider, useFromToContext } from '../../hooks';
import { ResetCallback, UpdateFromCallback, UpdateToCallback } from './types';
import DateFromToPicker from './DateFromToPicker';

const ViewComponent: React.FC = ({ children }) => {
    const { dateFromTo, setDateFromTo } = useFromToContext();
    const history = useHistory();
    const { dateTimeService } = useDateTimeService();

    const updateFromContext: UpdateFromCallback = (from, dateTo) => {
        if (from) {
            const params = setUrlParams(history.location.search, {
                from: dateTimeService.getIsoDateStringFromJsDate(from),
            });
            history.push({ search: params.toString() });
        }

        if (from && dateTo && (from.valueOf() <= dateTo.valueOf())) {
            setDateFromTo({ from, to: dateTo.toJSDate() });
        }
        if (from === null) {
            resetContext();
        }
    };

    const updateToContext: UpdateToCallback = (to, dateFrom) => {
        if (to) {
            const params = setUrlParams(history.location.search, {
                to: dateTimeService.getIsoDateStringFromJsDate(to),
            });
            history.push({ search: params.toString() });
        }
        if (to && dateFrom && (to.valueOf() >= dateFrom.valueOf())) {
            setDateFromTo({ to, from: dateFrom.toJSDate() });
        }
        if (to === null) {
            resetContext();
        }
    };
    const resetContext: ResetCallback = () => {
        setDateFromTo(undefined);
    };

    let startDate;
    let endDate;
    if (dateFromTo) {
        startDate = dateTimeService.getDateTimeFromJsDate(dateFromTo.from);
        endDate = dateTimeService.getDateTimeFromJsDate(dateFromTo.to);
    }
    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <Box p={2} component={Paper}>
                    <Box display='flex' alignItems='center' flexWrap='wrap'>
                        <Box width={320}>
                            <DateFromToPicker
                                startDate={startDate}
                                endDate={endDate}
                                resetCallback={resetContext}
                                updateFromCallback={updateFromContext}
                                updateToCallback={updateToContext}
                            />
                        </Box>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12}>
                {children}
            </Grid>
        </Grid>

    );
};

export const DateFilterContainer: React.FC<{ disableWrapper?: boolean }> = ({ children, disableWrapper }) => {
    const history = useHistory();
    const { dateTimeService } = useDateTimeService();
    const [from, to] = getUrlParams({ searchString: history.location.search, params: ['from', 'to'] });
    let fromTo: DateFromTo | undefined;
    if (from && to && new Date(from) <= new Date(to)) {
        fromTo = {
            from: dateTimeService.getStartOfTheDayJsDate(new Date(from)),
            to: dateTimeService.getEndOfTheDayJsDate(new Date(to)),
        };
    } else {
        const fromJsDate = dateTimeService.getStartOfTheDayJsDate(new Date());
        const toJsDate = dateTimeService.getEndOfTheDayJsDate(new Date());
        fromTo = {
            from: fromJsDate,
            to: toJsDate,
        };

        const params = setUrlParams(history.location.search, {
            from: dateTimeService.getIsoDateStringFromJsDate(fromJsDate),
            to: dateTimeService.getIsoDateStringFromJsDate(toJsDate),
        });

        history.push({ search: params.toString() });
    }

    const content = disableWrapper
        ? children
        : (
            <ViewComponent>
                {children}
            </ViewComponent>
        );

    return (
        <FromToContextProvider dateFromTo={fromTo}>
            {content}
        </FromToContextProvider>
    );
};

export default DateFilterContainer;
